import { LookTile } from '@Generated/graphql'
import { AlgoliaLookHit, Options, ProductSorting } from '@Globals/Algolia/Types'

export const LOOKS_FACETS = ['productTypes', 'ambassadorHandle']
export const LOOKS_BASE_FILTERS = 'hasAmbassador:true'
export const LOOKS_HITS_PER_PAGE = 60

// buildLooksOptions is the single source of truth for the looks query options.
// SSR and client must produce identical options — the SWR fallback key is a
// serialization of this object.
export function buildLooksOptions({
  facetFilters,
  locale,
  page,
}: {
  facetFilters: string[]
  locale: string
  page: number | null
}): Options {
  return {
    entity: 'looks',
    facetFilters,
    facets: LOOKS_FACETS,
    filters: LOOKS_BASE_FILTERS,
    hitsPerPage: LOOKS_HITS_PER_PAGE.toString(),
    locale,
    numericFilters: {},
    optionalFilters: [],
    page,
    pagination: true,
    sorting: ProductSorting.Default,
    sortingFeatureGroup: 'a',
    sortingGroup: 'a',
  }
}

// algoliaLookHitToLookTile renders a tile straight from the hit. Products are
// deliberately emptied: the 60-tile grid never renders pins, and empty pins
// make the "Shop the look" button appear.
export function algoliaLookHitToLookTile(hit: AlgoliaLookHit): LookTile {
  return {
    __typename: 'LookTile',
    ambassadorHandle: hit.ambassadorHandle || null,
    asset: {
      __typename: 'Image',
      dimensions: hit.asset?.dimensions,
      pins: [],
      url: hit.asset?.url,
    },
    id: hit.key?.toString() || '',
    products: [],
    title: hit.title || null,
    url: hit.url,
  } as unknown as LookTile
}
